const VIEW_ALL_CARD_COUNT = 1;

export const hasMoreGappers = (rowCount: number, totalElements: number, visibleRowCount: number): boolean => (
  totalElements > visibleRowCount || rowCount > visibleRowCount
);

export const getGapperCardCount = (rowCount: number, totalElements: number, visibleRowCount: number): number => {
  const renderedGapperCount = Math.min(rowCount, visibleRowCount);
  const viewAllCardCount = hasMoreGappers(rowCount, totalElements, visibleRowCount) ? VIEW_ALL_CARD_COUNT : 0;

  return renderedGapperCount + viewAllCardCount;
};
